module.exports = __webpack_public_path__ + "media/images/talent/lp/case03-7aa1168ebb594098d6048465b73cabe8.png";